
const Button = ({children, style, onClick}) => {
  return (
    <button style={style} className='button open-button' onClick={onClick}>{children}</button>
  )
}

export default Button